export default "__VITE_ASSET__16adea5e__"